import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "#F0EBFB"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4C4DEE",
  d: "M17 17a1.25 1.25 0 0 1-1.87 1.085l-2.82-1.611a.63.63 0 0 0-.62 0l-2.82 1.611A1.25 1.25 0 0 1 7 17V7.625A1.875 1.875 0 0 1 8.875 5.75h6.25A1.875 1.875 0 0 1 17 7.625z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }